import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';

const TermAndCondtions = () => {
    const abbreviations = [
        { abbreviation: 'SMS', description: 'Short Messaging Service' },
        { abbreviation: 'T&C', description: 'Terms and Conditions' },
        { abbreviation: 'TRAI', description: 'Telecom Regulatory Authority of India' },
        { abbreviation: 'SMSC', description: 'Short Message Service Center' },
        { abbreviation: 'Sender-ID', description: 'The name in which the SMS is sent' },
        { abbreviation: 'OTP', description: 'One Time Password' }
    ];

    return (
        <Box p={2}
        >
            <Typography
                variant="body1"
                gutterBottom
                sx={{ fontWeight: 'bold', color: 'black', fontSize: '1.375rem' }}

            >
                The Terms and Conditions specify the actions permitted by Provider Company to its users of our services, including SMS and other services, which may be introduced in the future. The Company reserves right to modify the policy at any time. All subscribers of Our Services, directly or indirectly are required to engage in acceptable use only as per this policy as modified from time to time.
            </Typography>
            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                1. Illegal Use
            </Typography>
            <Typography variant="body2" paragraph>
                A. The Services of the Provider Company should be used only for lawful purposes.
                Transmission, distribution or storage of any material in violation of any applicable law
                or regulation is prohibited. This includes, without limitation, material protected by
                copyright, trademark, trade secret, fraudulent, spam or other intellectual property
                right used without proper authorization, and material that is obscene, defamatory,
                constitutes an illegal threat, and violates export control laws or anti national.
                The provider company will not be held LIABLE for use of any such activity by its users.

            </Typography>
            <Typography variant="body2" paragraph>
                B. The USER has agreed not to send any unsolicited commercial communication and not to
                mix any promotional communications with its Transactional Message sent to a subscriber
                through telecom resource allotted to it for the purposes of sending Transactional
                Message.
            </Typography>
            <Typography variant="body2" paragraph>
                C. The USER shall maintain complete confidentiality of the customer information.
            </Typography>
            <Typography variant="body2" paragraph>
                D. The USER has agreed to obtain telecom resources from the “Provider Company” for the purposes of sending transactional message.
            </Typography>
            <Typography variant="body2" paragraph>
                E. The USER has agreed not to make unsolicited commercial communications to any subscriber whose telephone number appears on
                the National Customer Preference Register, except for sending Transactional Message.
            </Typography>
            <Typography variant="body2" paragraph>
                F. The USER will be solely liable for content provided / submitted to the Provider Company
                servers to be made available and/or to deliver to the end users or subscribers designated by
                the USER and will ensure that the information passed on to its customers by using the Provider
                Company service platform do not violate any prevailing DOT/ TRAI rules or Judicial laws. The
                USER shall be solely responsible for any NDNC violations/complaints/fines /justifications/
                Penalties imposed on account of NDNC / NCPR complaints by the operator (Access Service
                Provider) / recipients as per the TRAI norms and notifications for the Services rendered
                by the Provider Company to USER under this arrangement. The USER will obtain prior
                permission from the subscribers explicitly and keep record of any such permissions.

            </Typography>
            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                2. Applicable Law
            </Typography>
            <Typography
                variant="body2"
                paragraph
                sx={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'black' }}
            >
                All applicable international, national, federal, state and local laws, rules, regulations, directives, statements, and codes of practice, including any export/import laws, relating to any or all countries in the Territory or otherwise.  Applicable Law includes any rules promulgated by any Regulator (including the TRAI Regulations) and, additionally for the Republic of India, the Indian Telegraph Act, the Wireless Telegraphy Act, TCCCP Regulations and the Telecom Regulatory Authority of India Act.
            </Typography>
            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                3. Subscriber Conduct
            </Typography>
            <Typography variant="body2" paragraph>
                Subscriber shall use Company services for lawful purposes only. Subscriber shall not post
                or transmit using Company services any material, which violates or infringes in any way
                upon the rights of others, which is unlawful, threatening, abusive, defamatory, invasive
                of privacy or publicity rights, vulgar, obscene, profane or otherwise objectionable,
                which encourages conduct that would constitute a criminal offence, give the right to
                civil liability or otherwise violate any law, or which, without the Company express
                prior approval, contains advertising or any solicitation with respect to products
                or services. Any conduct by a Subscriber that in the Company discretion restricts
                or inhibits any other Subscriber from using or enjoying Company services will
                not be permitted. Subscriber shall not use Company services to advertise or
                perform any commercial solicitation, including, but not limited to, the
                solicitation of users to become subscribers of other on-line information
                services competitive with the Company services.

            </Typography>
            <Typography variant="body2" paragraph>
                Subscriber shall not upload, post or otherwise make available using Company services any
                material protected by copyright, trademark or other proprietary right without the express
                permission of the owner of the copyright, trademark or other proprietary right and the
                burden of determining that any material is not protected by copyright rests with the
                subscriber. Subscriber shall be solely liable for any damage resulting from any
                infringement of copyrights, proprietary rights, or any other harm resulting from
                such a submission.
            </Typography>
            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                4. System and Network Security
            </Typography>
            <Typography variant="body2" paragraph  >
                Violations of system or network security are prohibited, and may result in criminal and civil liability. The Company will investigate incidents involving such violations and may involve/will cooperate with law enforcement agencies if a criminal violation is suspected. Examples of system or network security violations include, without limitation, the following:
            </Typography>
            <ul style={{ paddingLeft: '1.2rem' }}>
                {[
                    "Unauthorized access to or use of data, systems or networks, including any attempt to probe, scan or test the vulnerability of a system or network or to breach security or authentication measures without express authorization of the owner of the system or network.",
                    "Unauthorized monitoring of data or traffic on any network or system without express authorization of the owner of the system or network.",
                    "Interference with service to any user, host or network including, without limitation, mail bombing, flooding, deliberate attempts to overload a system and broadcast attacks.",
                    "Forgery of any identification or obscuring of host names, usernames, IP addresses, or any message header information in any data.",
                    "Harassing or threatening transmissions.",
                    "Probing for means of gaining unauthorized access to computers or networks.",
                    "Introducing or causing to be introducing any computer contaminant or computer viruses into system or network.",
                    "Introducing or causing to introduce any pornography material, SMS, and so on."
                ].map((item, index) => (
                    <li key={index} >
                        {item}
                    </li>
                ))}
            </ul>
            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                5. Indemnification
            </Typography>
            <Typography variant="body2" paragraph>
                Subscribers agree to defend, indemnify and hold harmless the Company, its affiliates and
                their respective directors, officers, employees and agents from and against all claims
                and expenses, including attorney's fees, arising out of the use of Company Services by
                the subscriber or anybody else than the Subscriber, if any.
            </Typography>
            <Typography variant="body2" paragraph>
                If the USER makes any unsolicited commercial communication, through the telecom resources
                allotted to it by the Provider Company for sending Transactional Message, to any
                subscriber whose telephone number appears in the National Customer Preference Register,
                the USER agrees that-
            </Typography>
            <Typography variant="body2" paragraph>
                on the issue of first notice by the Provider Company on getting information by the Access Provider
                for violation by the USER for sending such unsolicited commercial communication, a sum of rupees
                Twenty Five Thousand only (Rs. 25000/-) shall be paid by the USER to the Provider Company and
                deposited in the account as may be specified by TRAI, from time to time;
            </Typography>
            <Typography variant="body2" paragraph>
                on the issue of the second notice by the Provider Company on getting information by the
                Access Provider for violation by the USER for sending such unsolicited commercial communication,
                a sum of rupees Seventy Five Thousand only (Rs. 75000/-) shall be paid by the USER to the
                Provider Company and deposited in the account as may be specified by TRAI, from time to time;
            </Typography>
            <Typography variant="body2" paragraph>
                on the issue of the third notice by the Provider Company on getting information by the
                Access Provider for violation by the USER for sending such unsolicited commercial communication,
                a sum of rupees Eighty Thousand only (Rs. 80000/-) shall be paid by the USER to the Provider
                Company and deposited in the account as may be specified by TRAI, from time to time;
            </Typography>
            <Typography variant="body2" paragraph>
                on the issue of the fourth notice by the Provider Company on getting information by the
                Access Provider for violation by the USER for sending such unsolicited commercial communication,
                a sum of rupees One Lac Twenty Thousand only (Rs. 1,20,000/-) shall be paid by the USER to the
                Provider Company and deposited in the account as may be specified by TRAI, from time to time;
            </Typography>
            <Typography variant="body2" paragraph>
                on the issue of the fifth notice by the Provider Company on getting information by the Access
                Provider for violation by the USER for sending such unsolicited commercial communication, a sum
                of rupees One Lac Fifty Thousand only (Rs. 1,50,000/-) shall be paid by the USER to the Provider
                Company and deposited in the account as may be specified by TRAI, from time to time;
            </Typography>
            <Typography variant="body2" paragraph>
                on the issue of the sixth notice by the Provider Company on getting information by the Access Provider for
                violation by the USER for sending such unsolicited commercial communication, a sum of rupees Two Lac
                Fifty Thousand only (Rs. 2,50,000/-) shall be paid by the USER to the Provider Company and deposited
                in the account as may be specified by TRAI, from time to time;
            </Typography>
            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                6.   SMS
            </Typography>
            <Typography variant="body2" paragraph>
                It is a condition of use of Company services that subscriber does not post or transmit any
                unlawful, threatening, abusive, libelous, defamatory, obscene, vulgar, pornographic, profane or
                indecent information of any kind, including without limitation any transmissions constituting
                or encouraging conduct that would constitute a criminal offence, give rise to civil liability
                or otherwise violate any local, state, national or international law; post or transmit any
                information, software or any other material, which violates or infringes upon the rights
                of others, including material, which is invasion of privacy or publicity rights or, which
                is protected by copyright, trademark or other proprietary right, or derivative works with
                respect thereto, without first obtaining permission from the owner or right holder; post
                or transmit any information, software or other material, which contains a virus or other
                harmful component; post, transmit or in any way exploit any information, software or
                other material for commercial purposes, or, which contains advertising.
            </Typography>
            <Typography variant="body2" paragraph>
                User cannot use any sender Id to send SMS other than his own name, company or firm's name
                owned or managed by him/her. Using sender Id other than owned by him will cause the
                termination of account and all credits will be set to zero. A formal complaint will also
                be lodged (FIR) with the law and order agency.
            </Typography>
            <Typography variant="body2" paragraph>
                Sending unsolicited SMS messages, including, without limitation, commercial advertising and informational announcements, is explicitly prohibited.
            </Typography>
            <Typography variant="body2" paragraph>
                Company has no control on the contents of the SMS sent and Company shall not be held responsible/liable directly or indirectly neither for the content
                of the SMS sent nor for any delay in delivery or non-delivery or for any errors routed by Company
                through its SMSC.

            </Typography>
            <Typography variant="body2" paragraph>
                Company shall not be responsible in any manner due to errors caused on account of internet delays, disconnection, time outs, routing problems, and so on.
            </Typography>
            <Typography variant="body2" paragraph>
                User shall use the facilities provided by Company for delivery of MT SMS that terminates within
                India only. User also acknowledges that it will not use the capability of sending international
                SMS through Company SMSC.
            </Typography>
            <Typography variant="body2" paragraph>
                User will not send unsolicited SMS (also referred to as ‘spamming’) to subscribers. All SMS sent by the user using Company
                SMSC must conform to IT Act 2000 and other relevant laws of India. Any violation will be the sole
                responsibility of user.
            </Typography>
            <Typography variant="body2" paragraph>
                User has complete control of the Sender-ID (Alphanumeric or Numeric) of the MT SMS sent through Company
                SMS and will not misuse this facility. In case it is found that user is misusing this facility by
                sending a message on someone’s name without his/her approval, it shall be treated as a breach of
                this agreement and the connection will be disconnected forthwith. It shall be the sole responsibility
                of user and Company will in no way responsible for any such message and the subsequent fallout.
            </Typography>
            <Typography variant="body2" paragraph>
                Company shall strive to deliver SMS immediately upon receipt from the user. However, Company shall
                not be responsible for any delay, non receipt of SMS or any other interruption in providing SMSC
                facility, which may occur due to technical reasons or snags in the system, breakdown of SMSC or
                any other equipment, server breakdown, maintenance shutdown, breakdown of communication
                services and such interruption are beyond the control of Company. However, Company acknowledges
                that it will put in its best endeavors to achieve the best success rate in delivery of the SMS
                messages so routed through its SMSC.

            </Typography>
            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                7.   Cost policy
            </Typography>
            <Typography variant="body2" paragraph>
                A.      In consideration of Company forwarding the SMS through its SMSC, User shall pay the agreed amount per
                SMS + GST sent anywhere within India.

            </Typography>
            <Typography variant="body2" paragraph>
                B.      Company shall be entitled to charge for all the SMS routed by its SMSC, irrespective of any delay,
                incomplete message and or non-receipt of the message by the irrespective mobile phone to whom such
                SMS has been forwarded. Company will notify any change in tariff to User.
            </Typography>
            <Typography variant="body2" paragraph>
                C.      Company shall raise bills at the time of buying the credits by the user. The number of Empty SMS submitted by the user shall be counted for settlement.

            </Typography>
            <Typography variant="body2" paragraph>
                D.      GST would be as applicable, currently@18%.
            </Typography>
            <Typography variant="body2" paragraph>
                E.      User agrees to pay the bill amount immediately when sent by Company. Such payments shall be in Indian Rupees (INR) .
            </Typography>

            <Typography variant="body2" paragraph>
                F.      The bill generated by Company shall be the conclusive proof of the SMS sent by SMSC of Company and the same shall be honored by the user. However, in case of any anomaly found by the user, he will present its statistics and both parties will resolve the anomaly.
            </Typography>

            <Typography variant="body2" paragraph>
                G.      Company shall not be responsible in any manner whatsoever to a user or any other third party for delayed, incomplete and non-delivery of SMS due to technical reasons.

            </Typography>
            <Typography variant="body2" paragraph>
                H.      No unsolicited/objectionable message should be sent by the user.


            </Typography>
            <Typography variant="body2" paragraph>
                I.      Bulk SMS will be sent by the user to national customer only.
            </Typography>

            <Typography variant="body2" paragraph>

                J.  Incase TRAI / Operator(s) levies ANY Extra Charges above 1 Paisa per SMS e.g. interconnection Charges,
                the User will have to bear all such charges for the Balance SMS Credits in their account. The
                Provider Company reserves the Right to suspend User Account 7 days after giving a Notification
                by E-Mail or SMS to the Client in case the client does not deposit the Differential Amount to
                the Provider. A copy of all such Policies will be provided to the customer before charging
                anything extra.
            </Typography>

            <Typography variant="body2" paragraph>
                K.  Nature of content, intention behind sending bulk SMS, and the use of and primary applications to be specified by the user.
            </Typography>
            <Typography variant="body2" paragraph>
                L.  The Bulk SMS rates are subject to change.
            </Typography>

            <Typography variant="body2" paragraph>
                M.  In case of change/revision of IUC for inter operator termination charges; these bulk SMS charges will be revised.
            </Typography>

            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                8. Refund Policy
            </Typography>
            <Typography variant="body2" paragraph>
                Before starting any relationship with us. We advise you to test our services. We do not offer
                any refund of money at any stage or at any condition once the transaction has done, unless
                Company agreed.
            </Typography>

            <Typography variant="body2" paragraph>
                In case, Company agreed to refund money it will take 60 to 90 days but not more than that
                from the date of a request received by Company through an e-mail (registered with the Company)
                or by regular post. All charges like monthly fee (pro-rata basis), SMS charges, a 10% processing
                charges will be deducted from the refundable amount.

            </Typography>


            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                9.   Enforcement of Terms and Conditions for Company subscribers

            </Typography>

            <Typography variant="body2" paragraph>
                Indirect or attempted violations of the policy and actual or attempted violations by a third party
                on behalf of a Company subscriber or a subscriber's end user shall be considered a violation of
                the policy by such a customer or end user. Any user found violating the above Terms and
                Conditions is liable for action under the prevailing laws including termination of services
                without any prior notice.

            </Typography>

            <Typography variant="body2" paragraph>
                We also want to advise you that if, you do not agree with any of the conditions mentioned
                above kindly do not register with us, once the payment is received or, even if One SMS
                credit is consumed, the provider company will not be liable for a refund of the amount.
            </Typography>

            <Typography variant="body2" paragraph>
                Disclaimer: We hold the right to suspend and/or revoke credits from your account(s) or your
                child account(s) [For Reseller] in case of any violation or suspicious activity, without
                any notice.
            </Typography>

            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                10.   OTP (One Time Password) security check
            </Typography>

            <Typography variant="body2" paragraph>
                OTP( One Time Password) has been introduced in the website. Subscriber must receive the OTP on
                his/her registered mobile number. In case subscriber do not receive the OTP, he/she can
                re-generate the OTP. The OTP security check can be removed from the subscriber's login on
                request to the concerned account manager. but the we do not recommend the removal as during
                the event of leak out login and password the account can be miss used and the company will not
                be responsible for that.

            </Typography>

            <Typography variant="body2" paragraph>
                To remove the OTP security check the subscriber has to give the written recommendation that
                he/she will be sole responsible for the credits loss or any kind of spam messages posted from
                that particular account.
            </Typography>

            <Typography
                variant="h6"
                gutterBottom
                sx={{ color: '#1976d2', fontWeight: 'bold', fontSize: '1rem' }}
            >
                Appendix

            </Typography>
            <Typography variant="body2" paragraph>
                The following table provides information on all the terminologies used in this agreement.
            </Typography>

            <TableContainer component={Paper} sx={{ maxWidth: 600, mb: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>Abbreviation</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {abbreviations.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{item.abbreviation}</TableCell>
                                <TableCell>{item.description}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default TermAndCondtions;
